import classNames from 'classnames';

import css from './Brand.css';
import { resolveBrandLogo } from './resolveBrandLogo';

interface BrandProps {
  brandId: string;
  brandName: string;
  className?: string;
}

const Brand = ({ brandId, brandName, className }: BrandProps) => {
  const src = resolveBrandLogo(brandId);

  if (!src) {
    return <span className={className}>{brandName}</span>;
  }

  return (
    <img
      className={classNames(css.root, { [css.connection]: brandId === 'connection' }, className)}
      src={src}
      alt={brandName}
    />
  );
};

export default Brand;
